export default {
  route: {
    dashboard: '홈',
    documentation: '文档',
    guide: '引导页',
    permission: '权限测试页',
    rolePermission: '角色权限',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON 编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragSelect: '拖拽 Select',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    Table: 'Table',
    dynamicTable: '动态 Table',
    dragTable: '拖拽 Table',
    inlineEditTable: 'Table 内编辑',
    complexTable: '综合 Table',
    tab: 'Tab',
    form: '表单',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    externalLink: '外链',
    profile: '个人中心',
    translationmanager: '번역 관리',
    commoditymanager: '상품 관리',
    ordermanager: '배송대행',
    inboundscanning: '입고검색',
    systemmanager: '시스템 관리',
    platformconfiguration: '플랫폼 설정',
    storedetail: 'StoreDetail',
    memberlist: '멤버 목록',
    rolemanager: '역할 관리',
    warehousemanager: '창고 관리',
    putinwarehouse: '입고',
    putoutwarehouse: '출고',
    putoutwarehouseold: '出库（旧）',
    csmanager: '고객 관리',
    platformorder: '플랫폼 오더',
    agentorder: '배송대행신청',
    dictmanager: '사전 관리',
    hscode: '세관번호',
    translation: '번역',
    singleton: '단일 업로드',
    helptobuy: '代买订单',
    syssetting: '설정',
    inven: '재고관리',
    statementmanager: '결제 관리',
    orderlist: '주문목록',
    statementlist: '결제목록',
    billlist: '거래명세',
    balancelist: '잔액',
    inventorymanager: '재고관리',
    inventoryrecord: '재고 기록',
    inventorylist: '재고리스트',
    inventoryaudit: '입고 대기 리스트',
    goodscates: '상품유형',
    fee: '단가설정',
    price: '价格配置',
    balancedetail: '잔액명세',
    cslist: '고객명단',
    agentlist: '代理列表',
    goodsdetail: '商品详情',
    uploadrecord: '上传记录',
    agentorderdetail: '주문서 정보',
    collectlist: '采集列表',
    datamanager: '数据管理',
    orderdata: '订单数据'
  },
  main: {
    title: '홈',
    updatepwd: '비밀번호 변경',
    logout: '로그아웃',
    balance: '잔액',
    cname: '고객이름',
    ordercount: '발송수량',
    lastorderdate: '최종 발송시간',
    customcount: '고객수',
    copyurl: '영업용 URL 복사',
    balance: '잔액',
    tatolcz: '누적충전',
    morder: '이번달 배송'
  },
  member: {
    role: '역할',
    number: '넘버링',
    username: '사용자 이름',
    phone: '핸드폰 번호',
    ban: '봉쇄',
    unban: '해제',
    normal: '정상적인',
    addmember: '멤버 추가',
    updatememer: '구성원 편집',
    realname: '이름',
    password: '암호'
  },
  custom: {
    name: '이름',
    phone: '핸드폰 번호',
    ban: '봉쇄',
    unban: '해제',
    add: '고객 추가',
    update: '고객 편집',
    password: '암호',
    country: '국가',
    balance: '잔고',
    consume: '소비',
    recharge: '충전',
    refund: '환불',
    adminid: '생성한 사람',
    search: '사용자 이름이나 휴대폰번호를 입력해서 검색',
    currbalance: '현재 잔고',
    rechargeamount: '충당 금액',
    authorizationcode: '라이선스 코드',
    com: '회사',
    sendcount: '발송수량',
    cuscount: '하위 고객수',
    sy: '누적수익'
  },
  agent: {
    search: '현지 운송장번호 입력',
    downloadxls: '양식 다운로드',
    date: '날짜',
    customername: '고객이름',
    couriernumber: '송장번호',
    kcnumber: '库存数量',
    parcelnumber: '배송수량',
    goodsnumber: '제품수량',
    orderamount: '订单金额',
    allprint: '전체 프린트',
    address: '수취인 주소',
    phone: '수취인 전화번호',
    name: '수취인',
    danhao: '현지 운송장번호',
    danhaoko: '한국 운송장번호',
    gname: '상품명',
    count: '수량',
    idcard: '개인통관부호',
    create: '단일 업로드',
    edit: '데이터 수정',
    postcode: '우편번호',
    goodsnamezh: '중국어 상품명',
    goodsnameen: '영문 상품명',
    price: '가격',
    priced: '달러가격',
    sendremark: '배송 요청사항',
    unit: '단위',
    material: '재질',
    customer: '고객',
    weight: '무게',
    download: '파일다운로드',
    count_in: '입고수량',
    count_out: '출고수량',
    count_send: '박스수량',
    count_pkg: '택배수량',
    moresearch: '더 많은 정보검색',
    oldlist: '업로드 기록',
    inputgn: '상품명으로 검색',
    inputr: '수취인 정보로 검색',
    onlym: '묶음배송만 보기',
    remote: '도서산간'
  },
  navbar: {
    dashboard: '首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '오더 ERP',
    logIn: '로그인',
    username: '계정',
    password: '암호',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！',
    captacaa: '화살표를 오른쪽 끝으로 드레그 해주세요',
    captacab: '확인 했습니다',
    autologin: '로그인 상태 유지',
    forgotpwd: '비밀번호 찾기',
    forgotpwdlabel: '비밀번호 변경',
    resetpwd: '비밀번호 변경',
    pinputphone: '휴대전화번호 입력해 주세요',
    getcode: '인증번호 받기',
    backlogin: '로그인창으로 이동',
    register: '회원가입',
    registerlabel: '회원가입',
    pinputname: '이름 입력하세요',
    pinputcode: '인증번호 입력하세요',
    regis: '회원 가입',
    s: 's 후에 다시 받아주세요',
    success: '가입 축하드립니다！',
    suca: '초기 비밀번호는  전화번호 뒷 6개 숫자입니다，',
    sucb: '로그아웃으로 돌아가기！',
    sucd: '암호 초기화 성공！',
    xts: '시스템 도움말',
    hts: '슬라이더 인증 완료하기',
    ta: '오류가 발생했습니다',
    tb: '새로고침',
    tc: '버튼을 클릭하세요',
    td: '새로고침'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  action: {
    cancel: '취소',
    confirm: '확인'
  },
  status: {
    all: '전체',
    checked: '검사완료',
    uncheck: '데이터 확인',
    waitcheck: '테이터 확인',
    waitprint: '프린트 대기',
    outwed: '출고완료',
    inwed: '입고완료',
    printed: '프린트 완료',
    checking: '검사중',
    waitoutw: '출고대기',
    waitinw: '입고대기',
    inwing: '입고중',
    outwing: '출고중',
    waitsettle: '결제대기중',
    finish: '대행완료'
  },
  table: {
    empty: '데이터가 없습니다',
    title: '标题',
    importance: '重要性',
    type: '유형',
    remark: '비고',
    search: '검색',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: 'NO',
    date: '날짜',
    actions: '작업',
    edit: '편집',
    publish: '发布',
    draft: '草稿',
    delete: '삭제',
    cancel: '취소',
    confirm: '확인',
    createtime: '만든 날짜',
    updatetime: '업데이트 시간',
    status: '진행상태',
    print: '프린트',
    show: '조회',
    amount: '가격',
    check: '검사',
    remark_order: '판매자 기재란',
    volume: '부피 가',
    audit: '심사',
    invalid: '폐기',
    addmore: '재고보충',
    record: '기록'
  },
  example: {
    warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  pdf: {
    tips: '这里使用   window.print() 来实现下载pdf的功能'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  lan: {
    zh: '중국',
    ko: '한국',
    en: '영국',
    ja: '일본'
  },
  common: {
    upload: '대량 업로드',
    langSelect: '한글 버전으로 전환하였습니다',
    actionSuccess: '작업이 성공하다',
    pwdinit: '초기 비밀번호가 핸드폰 번호 뒤에 6자리',
    inputsearch: '검색',
    noimg: '상품 이미지 없습니다',
    rmb: 'RMB',
    krw: 'KRW',
    time: '날짜'
  },
  input: {
    name: '수취인 이름을 입력해주세요',
    phone: '수취인 전화번호를 입력해주세요',
    address: '수취인 주소를 입력해주세요',
    idcard: '수취인의 개인통관부호를 입력해주세요',
    postcode: '우편번호를 입력해주세요',
    danhao: '현지 운송장번호를 입력해주세요',
    gnamecn: '중국어 상품명을 입력해주세요',
    gnameen: '영문 상품명을 입력해주세요',
    price: '가격을 입력해주세요',
    remark: '비고를 입력해주세요',
    material: '재질을 입력해주세요',
    gname: '품목(HS) HS코드검색: 검색어를 이력 후 선택해주세요',
    count: '수량을 입력해주세요',
    spec: '재질/색상/사이즈'
  },
  check: {
    hscode: '정확한 상품명을 입력해 주세요'
  },
  upload: {
    ta: '여러 카테고리의 상품을 엑셀로 일괄 등록합니다',
    tb: '엑셀문서를 이쪽으로 끌어오거나  ',
    tc: '클릭해 주세요',
    td: '파일 제한: 5MB 이하의 .xlsx/.xls파일',
    te: '.xlsx/.xls 파일만 올릴수 있습니다!',
    tf: '첨부파일 용량 5MB 초과 할수 없습니다!'
  },
  logout: {
    la: '你已被登出，可以取消继续留在该页面，或者重新登录',
    lb: '确定登出',
    lc: '重新登录',
    ld: '취소'
  },
  singleton: {
    da: '수취인 정보',
    db: '배송정보',
    dc: '상품정보',
    merge: '묶음 배송',
    unmerge: '분리',
    couriercompany: '현지 택배사',
    imgupload: '상품 이미지 업로드',
    imgadd: '사진선택',
    create: '구매상품',
    inven: '재고상품',
    type: '유형',
    shipping: '해운',
    air: '항공',
    spec: '규격'
  },
  picker: {
    start: '시작날짜',
    end: '마감날짜',
    to: 'to',
    opa: '최근 1주',
    opb: '최근 1달',
    opc: '최근 90일'
  },
  inven: {
    create: '입고 데이터 작성',
    number: '재고번호'
  },
  statement: {
    date: '날짜를 하나 또는 여러 개 선택해주세요',
    statement: '결제',
    total: '합계',
    expressno: '송장번호',
    outdate: '출고날짜',
    customer: '고객',
    receiver: '수취인',
    bill: '청구서',
    statementcount: '결제 건수',
    weightsubtotal: '무게 추가',
    type: '결제 방식',
    costsubtotal: '공급가액',
    statementdate: '결제 시간',
    statementer: '담당자',
    statementamount: '합계',
    unstatementbill: '미결제 청구서',
    out: '청구서 엑셀 출력'
  },
  balance: {
    all: '전부',
    in: '충전',
    out: '지출',
    time: '거래시간'
  },
  bill: {
    bcount: '결제수량',
    m: '무게 추가 ',
    t: '결제 방식',
    f: '공급가액',
    bf: '합계',
    d: '결제 시간'
  },
  od: {
    info: '주문건 정보',
    invo: '배송정보',
    oper: '작업기록',
    upt: '업로드 날짜',
    int: '입고날짜',
    out: '출고날짜',
    type: '운송방식',
    zh: '중국현지 배송정보',
    hs: '통관물류정보',
    ko: '국내 배송정보',
    opt: '작업날짜',
    opname: '작업자'
  }
}
